import { render, staticRenderFns } from "./input-field.vue?vue&type=template&id=27a38fd7&"
import script from "./input-field.vue?vue&type=script&lang=ts&"
export * from "./input-field.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports